import React from 'react';
import classNames from 'classnames';
import { LazyImage } from 'project/lazy-image';
import { SpriteSvg } from 'project/sprite-svg';

const CourseToggleView = (props) => {
    const text = props.primaryView ? props.content.changedView : props.content.primaryContent;
    const stateCss = classNames({
        'is-active': props.primaryView
    });
    return (
        <button
            className={`button-round button-round--toggle is-border-white ${stateCss}`}
            onClick={props.toggleView}
        >
            <span className="button-content button-content--icon">
                <span>{text}</span>
                {
                    props.primaryView ?
                        <SpriteSvg
                            iconName="cross"
                            width="10"
                            height="10"
                        /> :
                        <span className="course__toggle-view-icon-wrapper of-contain">
                            <LazyImage image={'/-/media/Images/flag-yellow.png'} />
                        </span>
                }
            </span>
        </button>
    );
};

export default CourseToggleView;
